// extracted by mini-css-extract-plugin
module.exports = {"container":"j8hY2WT_qeNdVAQhgRQyE","link":"FX1e8JcRq-Iw2a1LFJZ9W appSubtitle"};